import {
  CondensedHeader,
  Flashy,
  Gutter,
  Icon,
  Layout,
  LayoutItem,
  Tiles,
  TilesItem,
} from '@axiom/ui';
import React from 'react';

import type { SupportActionType } from './SupportContactsModal';

const Options = [
  {
    icon: 'settings',
    title: 'IT or Technical Issue',
    desc: 'Sign-in problems, platform errors, or access issues',
    action: 'technicalIssue',
  },
  {
    icon: 'help-filled',
    title: 'Axiom Answers',
    desc: 'Benefits, Axiom policies, and timesheet questions',
    action: 'axiomAnswers',
  },
  {
    icon: 'avatar-filled',
    title: 'People At Axiom',
    desc: `PAX`,
    action: 'peopleAtAxiom',
  },
  {
    icon: 'help-filled',
    title: 'Opportunity Feed',
    desc: `Questions about opportunities you've seen in your Feed`,
    action: 'oppFeedQuestion',
  },
  {
    icon: 'avatar-filled',
    title: 'Profile Help',
    desc: 'Profile guidance, Action Needed items, and how Axiom works',
    action: 'profileHelp',
  },
  {
    icon: 'circle-info-filled',
    title: 'Something Else',
    desc: 'Something not listed above',
    action: 'somethingElse',
  },
] as const;

export type SupportContactsModalDefaultProps = {
  onClick: (action: SupportActionType) => void;
};

export const SupportContactsModalDefault = ({
  onClick,
}: SupportContactsModalDefaultProps) => {
  return (
    <Tiles stretched columnWidth={1}>
      {Options.map(option => {
        return (
          <TilesItem
            key={option.action}
            name={option.action}
            onClick={() => {
              onClick(option.action);
            }}
          >
            <Layout horizontalGutter="16px">
              <LayoutItem>
                <Flashy color="controlActiveSecondary">
                  <Icon name={option.icon} />
                </Flashy>
              </LayoutItem>
              <LayoutItem fluid>
                <CondensedHeader>{option.title}</CondensedHeader>
                <Gutter bottom="8px" />
                {option.desc}
              </LayoutItem>
              <LayoutItem>
                <Flashy color="controlActiveSecondary">
                  <Icon name="arrow-right" />
                </Flashy>
              </LayoutItem>
            </Layout>
          </TilesItem>
        );
      })}
    </Tiles>
  );
};
